module.exports = __webpack_public_path__ + "assets/google-workspace.b19a3126.svg";